const userReducerDefaultState = {
    info: {},
    pref: [],
    isAdminSession: false
};

export default (state = userReducerDefaultState, action) => {
    // console.log("USER",action.type)
    switch (action.type) {
        case 'LOGOUT':
            return {
                ...userReducerDefaultState
            };
        case 'SET_USER_INFO':
            return {
                ...state,
                info: action.info,
            };
        case 'SET_USER_PREF': {
            const dp = action.pref.find(p => p.name === 'DISPLAY');
            if (dp && dp.value) localStorage.setItem('displayView', dp.value);
            return {
                ...state,
                pref: action.pref,
            };
        }
        case 'UPDATE_USER_PREF': {
            const dp = action.pref.find(p => p.name === 'DISPLAY');
            if (dp && dp.value) localStorage.setItem('displayView', dp.value);
            return {
                ...state,
                pref: action.pref,
            };
        }
        case 'SET_ADMIN_SESSION':
            return {
                ...state,
                isAdminSession: action.isAdminSession,
            };
        default:
            return state;
    }
};